import moment from "moment";

export const initialValues = {
  title: "",
  body: "",
  expires: false,
  expiresAt: moment().add(1, "d"),
};
